export default ["MenuService","$rootScope", function dcMainMenuCollapse(MenuService, $rootScope) {

  return {
    restrict: "EA",
    require: "^dcPageContainer",
    link: function (scope, elem, attr, ctrl) {
      elem.bind("click", function (e) {
        ctrl.toggleMainMenu();
      });
    }
  };

}];



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-navigation/dc-main-menu-collapse.js